import React from "react";
import { useVideo } from "@100mslive/react-sdk";
import "../JoinScheduledEvent.scss";

const VideoTile = ({ peer, screenShareOn }) => {
  const { videoRef } = useVideo({
    trackId: peer.videoTrack,
  });

  return (
    <div
      className={` ${
        screenShareOn
          ? "main-video"
          : 
          peer.isLocal
          ? "main-video"
          : "others-video"
      }`} 
    >
      <div className="video-box">
        <div className="video-wrapper">
          <video
            ref={videoRef}
            autoPlay={true}
            playsInline
            muted={true}
            className={`${peer.isLocal ? "mirror" : ""}`}
          ></video>
          <div className="user-name">
            <div className="px-2 pb-1">
              {`${peer?.name}`}
              {peer.isLocal ? "(You)" : ""}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoTile;
